import keyBinder from 'shared/lib/keyBinder';
import CuesheetCursorActions from 'flux/actions/cuesheet/CuesheetCursorActions';
import KeyBindingActions from 'flux/actions/KeyBindingActions';
import { KeyScopes } from 'flux/stores/cuesheet/CuesheetConstants';

let bindings = [
  ['right', '_handleRightArrowKeyPress'],
  ['shift+right', '_handleRightArrowKeyPress'],
  ['tab', '_handleRightArrowKeyPress'],
  ['shift+tab', '_handleShiftTabKeyPress'],
  ['left', '_handleLeftArrowKeyPress'],
  ['shift+left', '_handleLeftArrowKeyPress'],
  ['up', '_handleUpArrowKeyPress'],
  ['shift+up', '_handleUpArrowKeyPress'],
  ['down', '_handleDownArrowKeyPress'],
  ['shift+down', '_handleDownArrowKeyPress'],
  ['alt+up', '_handleSelectNextTitleRowAbove'],
  ['alt+down', '_handleSelectNextTitleRowBelow'],
  ['alt+shift+up', '_handleSelectFirstRow'],
  ['alt+shift+down', '_handleSelectLastRow'],
];

export default {
  componentDidMount() {
    this._bindNavigationKeys();

    this.listenTo(
      KeyBindingActions.bindNavigationKeys,
      this.onBindNavigationKeys,
    );
    this.listenTo(
      KeyBindingActions.unbindNavigationKeys,
      this.onUnbindNavigationKeys,
    );
  },

  componentWillUnmount() {
    this._unbindNavigationKeys();
  },

  componentDidUpdate(prevProps, prevState) {
    /**
     * We do this to prevent nav keys from being triggered when popovers are visible
     */
    prevState = prevState || {};
    let state = this.state || {};
    let popoverPrevVisible = prevState.popoverVisible,
      popoverCurrVisible = state.popoverVisible;

    if (
      (!popoverCurrVisible && !popoverPrevVisible) ||
      (popoverCurrVisible && popoverPrevVisible)
    )
      return;

    if (!popoverCurrVisible && popoverPrevVisible) {
      this.onBindNavigationKeys();
    } else {
      this.onUnbindNavigationKeys();
    }
  },

  onBindNavigationKeys() {
    this._bindNavigationKeys();
  },

  onUnbindNavigationKeys() {
    this._unbindNavigationKeys();
  },

  _handleRightArrowKeyPress(e) {
    e.preventDefault();
    CuesheetCursorActions.moveCursorRight();
  },

  _handleLeftArrowKeyPress(e) {
    e.preventDefault();
    CuesheetCursorActions.moveCursorLeft();
  },

  _handleShiftTabKeyPress(e) {
    e.preventDefault();
    CuesheetCursorActions.moveCursorLeft(true);
  },

  _handleUpArrowKeyPress(e) {
    e.preventDefault();
    CuesheetCursorActions.moveCursorUp();
  },

  _handleDownArrowKeyPress(e) {
    e.preventDefault();
    CuesheetCursorActions.moveCursorDown();
  },

  _handleSelectNextTitleRowAbove(e) {
    e.preventDefault();
    CuesheetCursorActions.moveCursorToNextTitleRowAbove();
  },

  _handleSelectNextTitleRowBelow(e) {
    e.preventDefault();
    CuesheetCursorActions.moveCursorToNextTitleRowBelow();
  },

  _handleSelectFirstRow() {
    CuesheetCursorActions.moveCursorFirstRow();
  },

  _handleSelectLastRow() {
    CuesheetCursorActions.moveCursorLastRow();
  },

  /**
   * ### _bindNavigationKeys()
   *
   * Binds cue grid navigation keys
   *
   */
  _bindNavigationKeys() {
    //Don't create duplicate bindings
    if (this.state.keysBound) return;

    const keyBindings = bindings;

    /*
     * TODO: Figure out a good solution to prevent duplicate bindings.
     *
     * When the bind action is called twice it will rebind the keys causing
     * what ever action that was bound the first time and the second time to
     * be called twice. For instance the navigation keys were being bound
     * twice and so when you would hit the left arrow key once it would
     * move it over twice.
     */
    keyBindings.forEach((binding) => {
      let [key, handler, scope] = binding;
      keyBinder.assign(key, scope || KeyScopes.Default, this[handler]);
    });

    this.setState({ keysBound: true });
  },

  /**
   *
   * ### _unbindNavigationKeys()
   *
   */
  _unbindNavigationKeys() {
    bindings.forEach((binding) => {
      let [key, handler, scope] = binding;
      keyBinder.unbind(key, scope || KeyScopes.Default, this[handler]);
    });

    this.setState({ keysBound: false });
  },
};

// eslint-disable-next-line no-unused-vars
function _isFeaturedView() {
  return window.location.href.indexOf('/featured') >= 0;
}
